import { ReactElement } from 'react';

export function News(): ReactElement {
  return (
    <>
      <div className="container news-content">
        <h4>News</h4>
        <div className="news-photo">
          <img src="images/news3.gif" alt=" " />
        </div>
        <div className="news-photo-text">
          <h5>
            Nov. 2022: Prof. Shing-Chi Cheung elected as an{' '}
            <a href="https://cse.hkust.edu.hk/News/IEEE_Fellow2023/">
              IEEE Fellow
            </a>
          </h5>
          <p>
            Prof. Shing-Chi Cheung has been elected as an IEEE Fellow in
            November 2022.
          </p>
        </div>
        <div className="clearfix"> </div>
        <ul className="news-list">
          <li>
            <b>Jan. 2024: </b> Jiajun Hu and Jialun Cao have successfully
            defended their PhD thesis.
          </li>

          <li>
            <b> Nov. 2023: </b> One paper is accepted by IEEE S&P 2024.
          </li>

          <li>
            <b>Jul. 2023: </b> Three papers are accepted by ESEC/FSE 2023.
            Congrats to Ying, Ming, Jialun and Xiao.
          </li>

          <li>
            <b>Jul. 2023: </b> Huaxun Huang has successfully defended his PhD
            thesis.
          </li>

          <li>
            <b>Jul. 2023: </b> Two papers are accepted by ACM TOSEM. Congrats to
            Victor and Hengcheng.
          </li>

          <li>
            <b>Jul. 2023: </b> One paper on software testing using LLM is
            accepted by ASE'23. Congrats to Tsz-On.
          </li>

          <li>
            <b>Jul. 2023: </b> Yongqiang Tian has successfully defended his PhD
            thesis.
          </li>

          <li>
            <b>Jul. 2023: </b> Prof. Shing-Chi Cheung has been promoted to chair
            professorship.
          </li>

          <li>
            <b>Jun. 2023: </b> One paper is accepted by TOSEM.
          </li>

          <li>
            <b>May. 2023: </b> Three papers are accepted by ISSTA'23.
          </li>

          <li>
            <b>May. 2023: </b> Multiple papers are accepted by ACM TOSEM and
            IEEE TSE.
          </li>

          <li>
            <b>Nov. 2022: </b> Prof. Shing-Chi Cheung has been elected to the
            IEEE Fellow Class 2023.
          </li>

          <li>
            <b>Oct. 2022: </b> One paper accepted to ASE 2022.
          </li>

          <li>
            <b>Aug. 2022: </b> Lili Wei became Assistant Professor at McGill
            University.
          </li>

          <li>
            <b>Aug. 2022: </b> One paper is accepted by USENIX Security 2022.
          </li>

          <li>
            <b>May. 2022: </b> Three papers are accepted by ICSE 2022.
          </li>

          <li>
            <b>Jul. 2021: </b> Two papers are accepted by ASE'21.
          </li>

          <li>
            <b>May. 2021: </b> Two papers are accepted by FSE'21.
          </li>

          <li>
            <b>May. 2021: </b> One paper is accepted by Empirical Software
            Engineering.
          </li>

          <li>
            <b>May. 2021: </b> One paper got ICSE'21 Distinguished paper award.
          </li>

          <li>
            <b>Sep. 2020: </b> Yongqiang Tian published a{' '}
            <a href="https://yqtianust.github.io/awesome-ml-testing/">repo</a>{' '}
            for awesome machine learning materials
          </li>

          <li>
            <b>Oct. 2019: </b> Lili Wei received{' '}
            <a href="https://seng.ust.hk/news/20191031/leveraging-computer-science-turn-imagination-reality">
              SENG interview
            </a>
          </li>

          <li>
            <b>May. 2019: </b> Yongqiang Tian received Microsoft Cloud Software
            Research Fellow Award
          </li>

          <li>
            <b>Mar. 2019: </b> Ming Wen passed his PhD thesis defense.
            Congratulations!
          </li>

          <li>
            <b>Oct. 2018: </b> Lili Wei received 2018 Microsoft PhD Fellowship
            Award
          </li>

          <li>
            <b>Oct. 2018: </b> Lili Wei received{' '}
            <a href="https://ai.google/research/outreach/phd-fellowship/recipients/">
              2018 Google PhD Fellowship Award
            </a>
          </li>
          <li>
            <b>Jul. 2018: </b>{' '}
            <a href="https://cideranalyzer.github.io/">CIDER</a> accepted to ASE
            2018
          </li>
          <li>
            <b>Jul. 2018: </b>{' '}
            <a href="http://home.cse.ust.hk/~jhuao/wDroid.html">&omega;Droid</a>{' '}
            accepted to ASE 2018
          </li>
          <li>
            <b>Dec. 2018: </b>{' '}
            <a href="https://github.com/justinwm/CapGen">CapGen</a> accepted to
            ICSE 2018
          </li>
          <li>
            <b>Nov. 2017: </b>{' '}
            <a href="https://link.springer.com/epdf/10.1007/s10664-017-9567-4?author_access_token=dwdnatry6TOx-okPhHbSS_e4RwlQNchNByi7wbcMAY4bRi6jdBYn4RG-q8k1yPU6YsE5AI8wWS4MOTXWFqncFexMAjNf4xGcGMd7CmCOBjN5s7bgJa6gBQj-guEMXghGqIqG1QelnZAzXwiGdTiMQw%3D%3D">
              ChangeLocator
            </a>{' '}
            accepted to EMSE
          </li>
          <li>
            <b>Jun. 2017: </b>{' '}
            <a href="http://sccpu2.cse.ust.hk/oasis/">OASIS</a> accepted to FSE
            2017
          </li>
          <li>
            <b>Nov. 2016: </b> A large collection of resource leaks bugs in
            real-world Android apps,{' '}
            <a href="http://sccpu2.cse.ust.hk/droidleaks/">DroidLeaks</a>, has
            been released
          </li>
          <li>
            <b>Jul. 2016: </b>
            <a href="http://www.cse.ust.hk/~mwenaa/Locus.html">
              Locus
            </a> and{' '}
            <a href="http://sccpu2.cse.ust.hk/ficfinder/index.html">
              FicFinder
            </a>{' '}
            accepted to ASE 2016
          </li>
          <li>
            <b>Jun. 2016: </b>
            <a href="http://sccpu2.cse.ust.hk/elite/">Elite</a> accepted to FSE
            2016 and evaluated as a Platinum Artifact by the Artifact Evaluation
            Committee
          </li>
          <li>
            <b>Apr. 2016: </b>
            <a href="http://sccpu2.cse.ust.hk/csnippex/index.html">
              CSNIPPEX
            </a>{' '}
            accepted to ISSTA 2016 and artifact evaluated by the Artifact
            Evaluation Committee
          </li>
          <li>
            <b>Jan. 2016: </b>
            <a href="http://sccpu2.cse.ust.hk/custodes/">CUSTODES</a> and
            AutoConTest accepted to ICSE 2016
          </li>
          <li>
            <b>Oct. 2015: </b> Casper accepted to POPL 2016
          </li>
          <li>
            <b>Oct. 2014: </b> Yanyan Jiang received 2014 Microsoft Research
            Asia Fellowship Award
          </li>
        </ul>
      </div>
    </>
  );
}
